// extracted by mini-css-extract-plugin
export default {"infoBubble":"Tooltip_infoBubble__4-QrY","tooltip":"Tooltip_tooltip__tIirw"};